import React, { useEffect, useState } from 'react';
import ReactDOM  from 'react-dom';

import axios from 'axios';

import { AiFillCloseCircle } from "react-icons/ai";
import { IconContext } from "react-icons";

import {
    Container,
    Header,
    TitleHeader,
    CloseButtonHeader,
    Content
} from './styles';

interface IDealDetailModalProps {
    isModalVisible: boolean;
    hideModal: () => void;
    codDeal : string;
}

type IDealDetailFieldsProps = {
    nomeSolicitante: string;
    emailSolicitante: string;
    nomeResponsavel: string;
}

const DealDetailModal : React.FC<IDealDetailModalProps> = ({
    isModalVisible,
    hideModal,
    codDeal
}) => {

    const [dealDetail, setDealDetail] = useState<IDealDetailFieldsProps>();

    async function getDealData() {
        var respId;
        var contactId;
        let nomeSolicitante : string = "";
        var emailSolicitante : string = "";
        var nomeResponsavel : string = "";

        await axios.post('https://niatech.bitrix24.com.br/rest/1/9cwjchlqktog52yq/crm.deal.list', {
            "filter": {
                "ID": codDeal
            },
            "select": [
                "ID",
                "ASSIGNED_BY_ID",
                "CONTACT_ID"
            ],
            "start": -1
        }).then(response => {
            respId = response.data.result[0].ASSIGNED_BY_ID;
            contactId = response.data.result[0].CONTACT_ID;
        })

        await axios.post('https://niatech.bitrix24.com.br/rest/1/9cwjchlqktog52yq/crm.contact.list', {
            "filter": {
                "ID": contactId
            },
            "select": [
                "ID",
                "NAME",
                "EMAIL"
            ],
            "start": -1
        }).then(response => {
            nomeSolicitante = response.data.result[0].NAME;
            emailSolicitante = response.data.result[0].EMAIL[0].VALUE;
        })

        await axios.post('https://niatech.bitrix24.com.br/rest/1/9cwjchlqktog52yq/user.get', {
            "id": respId
        }).then(response => {
            nomeResponsavel = response.data?.result[0]?.NAME;
        })

        var deal : IDealDetailFieldsProps = {
            nomeSolicitante: nomeSolicitante,
            emailSolicitante: emailSolicitante,
            nomeResponsavel: nomeResponsavel
        }

        setDealDetail(deal);
    }

    useEffect(() => {

        getDealData();

    },[])

    const modal = (
        <Container>
            <Header>
                <TitleHeader>
                    Detalhes do Chamado:
                </TitleHeader>
                <CloseButtonHeader onClick={hideModal}>
                    <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                        <AiFillCloseCircle />
                    </IconContext.Provider>
                </CloseButtonHeader>
            </Header>
            <Content>
                <p><strong>Nome do Solicitante:</strong> {dealDetail?.nomeSolicitante}</p>
                <p><strong>E-mail do Solicitante:</strong> {dealDetail?.emailSolicitante}</p>
                <p><strong>Nome do Responsável:</strong> {dealDetail?.nomeResponsavel}</p>
            </Content>
            
        </Container>
    )

    return isModalVisible ? ReactDOM.createPortal(modal, document.body) : null;
}

export default DealDetailModal;